import React from 'react'
import auth from '../auth'

import {
  Input,
  Button,
  List
} from '../components'

import logo from '../assets/img/MessagePlus_logo.png'


class LoginResetPasswordRequest extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      email: '',
      resetRequestResult: false,
      showError: false,
      errorFlags: []
    }
  }

  requestResetPassword = (e) => {
    if (this.isValidEmail()) {
      e.preventDefault()
      this.setState({ showError: false })
      auth.requestResetPassword(this.state.email, (result) => {
        if (result.requested) {
          let response = (
            <span>
              <div className="slds-text-heading_medium">We have sent you an email with the next step</div>
              <p>We have sent an email to {this.state.email}. If you do not receive the email within 10 minutes, please contact us.</p>
            </span>
          )
          this.setState({ resetRequestResult: response})
        } else {
          let response = (
            <span>Reset request failed. Please refresh your browser and try again.</span>
          )
          this.setState({ resetRequestResult: response})
        }
      })
    } else {
      this.setState({
        showError: true
      })
    }
  }

  isValidEmail = () => {
    let fails = []
    // eslint-disable-next-line no-useless-escape
    let emailRegex = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
    if (!emailRegex.test(this.state.email)) {
      fails.push("is not valid email address")
    }

    this.setState({
      errorFlags: fails
    })

    if (fails.length > 0) {
      return false
    } else {
      return true
    }
  }

  render() {

    if (this.state.resetRequestResult) {
      return (
        <div className="slds-grid slds-grid--vertical-align-center slds-grid--align-center">
          <section className="slds-m-bottom_xx-large">
            <br />
            <img src={logo} alt="Picsa Logo" style={{ height: '100px' }} />
            <hr />
            { this.state.resetRequestResult }
          </section>
        </div>
      )
    }

    return (
      <div className="slds-grid slds-grid--vertical-align-center slds-grid--align-center">
      <section className="slds-m-bottom_xx-large">
        <br />
        <img src={logo} alt="Picsa Logo" style={{ height: '100px' }} />
        <hr />
        <div className="slds-text-heading_medium">
          Let’s help you create a new password.<br />Please enter the email address you are registered with.
        </div>
        <div className="slds-form slds-form--stacked">
          {this.state.showError
            ? <React.Fragment>
                <Input
                  label="Email address"
                  hasError={true}
                  value={this.state.email}
                  onChange={(e) => this.setState({ email: e.target.value })}
                />
                <div className='slds-text-color_error slds-m-top_small slds-m-bottom_large'>
                  Please try again.
                  <List
                    items={this.state.errorFlags}
                    type="dotted"
                  />
                </div>
              </React.Fragment>
            : <Input
                label="Email address"
                value={this.state.email}
                onChange={(e) => this.setState({ email: e.target.value })}
              />
          }
          <div className="slds-form-element">
            <Button
              type="brand"
              className="u-text-caps"
              onClick={this.requestResetPassword}
              disabled={this.state.email.length === 0}
              minWidth={100}>
              Create
            </Button>
          </div>
          <div className="slds-form-element">
            <div className="slds-text-body--regular slds-p-bottom_small">
              If you need any further assistance please email us at <a href="mailto:nicki@picsa.com">nicki@picsa.com</a>
            </div>
          </div>
        </div>
      </section>

      </div>
    )
  }
}


export default LoginResetPasswordRequest



// WEBPACK FOOTER //
// ./src/containers/LoginResetPasswordRequest.js